import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import ImageBlock from 'components/structure/ImageBlock';
import { paddingBuilder } from 'styles/themeUtils';
import { DEFAULT_LOCALE } from 'utils/i18nUtils';

import { PriceBoxContent, PriceBox } from './styles/PriceBox';

function SectionSignUp() {
  const intl = useIntl();

  return (
    <Section>
      <FormattedMessage id="REWARDS.SIGNUP.IMAGE_ALT">
        {([alt]) => (
          <ImageBlock
            alt={alt}
            loading="lazy"
            backgroundImage="gift-illustration/gift-illustration.png"
            mobileOrder={2}
            padding={{
              default: paddingBuilder.top(0),
              desktop: paddingBuilder.right(0),
            }}
          />
        )}
      </FormattedMessage>

      <Block>
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          intlKey="REWARDS.SIGNUP.TITLE"
        />

        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="light"
          intlKey="REWARDS.SIGNUP.TEXT"
        />

        <PriceBoxContent>
          <PriceBox>
            <Typography variant="action">
              <FormattedMessage id="REWARDS.SIGNUP.MONTH">
                {txt => `R$19/${txt}`}
              </FormattedMessage>
            </Typography>
          </PriceBox>

          <PriceBox>
            <Typography variant="action">
              <FormattedMessage id="REWARDS.SIGNUP.YEAR">
                {txt => `R$190/${txt}`}
              </FormattedMessage>
            </Typography>
          </PriceBox>
        </PriceBoxContent>

        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="light"
          intlKey="REWARDS.SIGNUP.TRIAL"
          gutterBottom={2}
        />

        {intl.locale === DEFAULT_LOCALE && (
          <Link
            href={intl.formatMessage({ id: 'REWARDS.SIGNUP.BUTTON.LINK' })}
            color="primary"
            intlKey="REWARDS.SIGNUP.BUTTON.TEXT"
            variant="action"
          />
        )}
      </Block>
    </Section>
  );
}

export default React.memo(SectionSignUp);
